import { action, computed, observable } from "mobx";
import { StoreBase } from "./storeBase";
import {
  AssertionAnswers,
  AssertionType,
  defaultPreAssertionAnswers,
} from "domain/assertions";
import { ApplicationError } from "domain/error";
import { generateApplicationError } from "domain/hardstop";
import { Nullable } from "util/extendedTypes";

export class AssertionStore extends StoreBase<AssertionAnswers> {
  constructor() {
    super(() => defaultPreAssertionAnswers());
  }

  @observable
  applicationError: Nullable<ApplicationError> = null;

  @computed
  public get answers(): AssertionAnswers {
    return this.data! || defaultPreAssertionAnswers();
  }

  @action
  submitPreAssertions = (answers: AssertionAnswers): AssertionAnswers => {
    return (this.data = answers);
  };

  @action
  generateError = (type: AssertionType): ApplicationError => {
    return (this.applicationError = generateApplicationError(type));
  };
}
